<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm văn phòng</div>
      <div v-else>Chỉnh sửa văn phòng</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm văn phòng'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã văn phòng (*)</label>
            <div class="p-col-8">
              <InputMask mask="**" v-model="code"  id="code" type="text" class="p-col-width" placeholder="Nhập mã văn phòng(2 ký tự)" />
              <small
                v-if="validationErrors && validationErrors['code']"
                class="p-invalid"
              >{{validationErrors['code']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã số thuế</label>
            <div class="p-col-8">
              <InputText v-model="tax_code"  id="tax_code" type="text" class="p-col-width" placeholder="Nhập mã số thuế" />
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Tên văn phòng (*)</label>
            <div class="p-col-8">
              <InputText v-model="name"  id="name" type="text" class="p-col-width" placeholder="Nhập tên văn phòng" />
              <small
                v-if="validationErrors && validationErrors['name']"
                class="p-invalid"
              >{{validationErrors['name']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Số điện thoại</label>
            <div class="p-col-8">
              <InputMask  v-model="phone"  mask="9999999999" id="phone" type="text" class="p-col-width" placeholder="Nhập số điện thoại" />
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Địa chỉ</label>
            <div class="p-col-8">
              <InputText v-model="address"  id="address" type="text" class="p-col-width" placeholder="Nhập địa chỉ" />
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      address: '',
      name: '',
      tax_code: '',
      code: '',
      phone: '',
      listOfficeTpl: []
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.office_tpl_id = this.$route.params.id
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      console.log('-------------------------------')
      this.validationErrors = {};
      var has_error = false
      if (this.name === '') {
        this.validationErrors['name'] = 'Vui lòng nhập tên văn phòng';
        has_error = true
      }
      if (this.code === '') {
        this.validationErrors['code'] = 'Vui lòng nhập mã văn phòng';
        has_error = true
      } else {
        if (this.mode == 'add') {
          let query = `query MyQuery($code: String) {
            office_tpl(where: {code: {_like: $code}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.office_tpl[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã văn phòng bị trùng';
                has_error = true
                this.$forceUpdate()
              }
            })
        } else {
          let query = `query MyQuery($code: String, $id: Int) {
            office_tpl(where: {code: {_like: $code}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.office_tpl[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã văn phòng bị trùng';
                has_error = true
                this.$forceUpdate()
              }
            })
        }
      }
      return has_error
    },
    async analyzeData() {
      console.log('dâdadadadadadad')
      var data_office_tpl = {}
        data_office_tpl['tax_code'] = this.tax_code
        data_office_tpl['name'] = this.name
        data_office_tpl['code'] = this.code
        data_office_tpl['phone'] = this.phone
        data_office_tpl['address'] = this.address
      return data_office_tpl
    },
    async analyzeDataEdit() {
      var data_office_tpl = {}
        data_office_tpl['tax_code'] = this.tax_code
        data_office_tpl['name'] = this.name
        data_office_tpl['code'] = this.code
        data_office_tpl['phone'] = this.phone
        data_office_tpl['address'] = this.address
      return data_office_tpl
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_office_tpl = await this.analyzeData()

        var query = `mutation MyMutation($objects: [office_tpl_insert_input!]!) {
            insert_office_tpl(objects: $objects) {
              affected_rows
              returning {
                id
                name
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_office_tpl]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-office_tpl'
              }, 500)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_office_tpl_update = await this.analyzeDataEdit()
        // let group_permission_id = await this.getGroupPerId()
        let query = `mutation MyMutation($office_tpl_id: Int!, $office_tpl_update: office_tpl_set_input) {
          update_office_tpl(where: {id: {_eq: $office_tpl_id}}, _set: $office_tpl_update) {
            affected_rows
            returning {
              id
              name
            }
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              office_tpl_id: this.office_tpl_id,
              office_tpl_update: data_office_tpl_update,
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-office_tpl'
              }, 500)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    office_tpl: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            office_tpl(where: {id: {_eq: $id}}) {
              id
              name
              code
              phone
              address
              tax_code
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
        if(data.office_tpl){
          this.listOfficeTpl = data.office_tpl
          this.name = this.listOfficeTpl[0].name
          this.code = this.listOfficeTpl[0].code
          this.tax_code = this.listOfficeTpl[0].tax_code
          this.phone = this.listOfficeTpl[0].phone
          this.address = this.listOfficeTpl[0].address
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
